var _excluded = ["url"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { ExternalLinkIcon } from '@domain-group/fe-co-icon';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import { Button, Card, Modal } from '@domain-group/fe-co-allhomes-design-system';
import { ModalCard } from './components/modal-card';
import PaginationDots from './components/pagination-dots';
import { subtitlePrefix, subtitleSuffix, truncateTextToNearestSpace } from './components/utils';
import Footer from './components/footer-old';
import * as styles from './allhomes-agent-recommendations-old.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AllhomesAgentRecommendationsOld = _ref => {
  var url = _ref.url,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var reviews = (props.reviews || []).slice(0, 5);
  var hasReviews = reviews.length > 0;

  // Show and hide modal
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showModal = _useState2[0],
    setShowModal = _useState2[1];

  // Modal Slide content and current animation
  var _useState3 = useState({
      activeSlide: 0,
      slideAnimation: 'enterFromRight'
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    state = _useState4[0],
    setState = _useState4[1];

  // for resetting the scroll on slide
  var modalRef = useRef();

  // for Slide transition (scroll reset will use the modalBodyRef)
  var activeSlide = state.activeSlide,
    slideAnimation = state.slideAnimation;
  var nextSlide = () => {
    sendEvent('next-review');
    setState(_objectSpread(_objectSpread({}, state), {}, {
      slideAnimation: 'exitToLeft'
    }));
  };
  var prevSlide = () => {
    sendEvent('previous-review');
    setState(_objectSpread(_objectSpread({}, state), {}, {
      slideAnimation: 'exitToRight'
    }));
  };

  // actual slide incrementation will happen onAnimationEnd on ModalCard component
  var incrementSlide = () => {
    modalRef.current.resetScroll();
    var newSlide = activeSlide + 1;
    setState({
      activeSlide: newSlide,
      slideAnimation: 'enterFromRight'
    });
  };
  var decrementSlide = () => {
    modalRef.current.resetScroll();
    var newSlide = activeSlide - 1;
    setState({
      activeSlide: newSlide,
      slideAnimation: 'enterFromLeft'
    });
  };
  var handleCardClick = reviewIndex => {
    sendEvent('expand-review');
    modalRef.current.resetScroll();
    var newSlide = reviewIndex;
    setState({
      activeSlide: newSlide,
      slideAnimation: 'enterFromRight'
    });
    setShowModal(true);
  };
  var modalActions = [___EmotionJSX(Button, {
    appearance: "ghost",
    disabled: activeSlide === 0,
    onClick: prevSlide,
    key: "action1"
  }, "Previous"), ___EmotionJSX(Button, {
    appearance: "ghost",
    disabled: activeSlide === reviews.length - 1,
    onClick: nextSlide,
    key: "action2"
  }, "Next")];
  var modalFooterContent = () => ___EmotionJSX("div", {
    css: styles.modalFooter
  }, ___EmotionJSX(Button, {
    appearance: "ghost",
    disabled: activeSlide === 0,
    onClick: prevSlide,
    key: "action1",
    css: styles.modalFooterButton
  }, "Previous"), ___EmotionJSX(PaginationDots, {
    activeSlide: activeSlide,
    pages: reviews
  }), ___EmotionJSX(Button, {
    appearance: "ghost",
    disabled: activeSlide === reviews.length - 1,
    onClick: nextSlide,
    key: "action2",
    css: styles.modalFooterButton
  }, "Next"));
  var openReviewProfile = () => {
    sendEvent('open-review-profile');
    var win = window.open(url, '_blank');
    win.opener = null;
  };
  return hasReviews ? ___EmotionJSX("section", {
    css: styles.container
  }, ___EmotionJSX("div", {
    css: styles.header
  }, ___EmotionJSX("div", {
    css: styles.heading
  }, "Recommendations"), url && ___EmotionJSX(Button, {
    css: styles.headerButton,
    iconPosition: "right",
    appearance: "ghost",
    icon: ___EmotionJSX(ExternalLinkIcon, null),
    onClick: openReviewProfile
  }, "View All")), reviews.map((review, index) => {
    var _review$propertyAddre;
    var title = review.title,
      date = review.date,
      description = review.description;
    return ___EmotionJSX(Card, {
      key: "".concat(title).concat(date),
      css: styles.card,
      onClick: () => {
        handleCardClick(index);
      }
    }, ___EmotionJSX("div", {
      css: styles.cardTitle
    }, title), ___EmotionJSX("div", {
      css: styles.cardSubtitle
    }, ___EmotionJSX("span", {
      css: styles.cardSubtitlePrefix
    }, subtitlePrefix(review.type, (_review$propertyAddre = review.propertyAddress) === null || _review$propertyAddre === void 0 ? void 0 : _review$propertyAddre.suburb)), ___EmotionJSX("span", {
      css: styles.cardSubtitleSuffix
    }, subtitleSuffix(review.date))), ___EmotionJSX("p", {
      css: styles.cardMessage
    }, truncateTextToNearestSpace(description)));
  }), ___EmotionJSX(Footer, null), ___EmotionJSX(Modal, {
    show: showModal,
    onClose: () => setShowModal(false),
    actions: modalActions,
    footer: modalFooterContent(),
    ref: modalRef,
    mobileStyle: "75perc",
    showHeader: false
  }, ___EmotionJSX(ModalCard, {
    show: showModal,
    animation: slideAnimation,
    review: reviews[activeSlide],
    onAnimationEnd: _event => {
      if (slideAnimation === 'exitToLeft') {
        incrementSlide();
      }
      if (slideAnimation === 'exitToRight') {
        decrementSlide();
      }
    }
  }))) : null;
};
AllhomesAgentRecommendationsOld.propTypes = {
  reviews: PropTypes.arrayOf(PropTypes.shape({})),
  url: PropTypes.string
};
AllhomesAgentRecommendationsOld.defaultProps = {
  reviews: [],
  url: ''
};
export { AllhomesAgentRecommendationsOld };